function documentBody() {
  // mobile browser compatibility
  return document.body || document.getElementsByTagName('body')[0];
}

export function hasScrollBar() {
  return documentBody().scrollHeight > documentBody().clientHeight;
}

// returns 0 if scroll bar is overlaid over div in some browser styles
export function scrollBarWidth() {
  var outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.width = "100px";
  outer.style.height = "100px";
  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
  // force scrollbars
  outer.style.overflow = "scroll";
  documentBody().appendChild(outer);
  var widthWithScroll = outer.offsetWidth;
  var widthNoScroll = outer.clientWidth;
  // remove divs
  outer.parentNode.removeChild(outer);
  return widthWithScroll - widthNoScroll;
}

export function setBackgroundScrollable(scrollable, options) {
  if (scrollable) {
    documentBody().style.overflowY = 'auto';
    documentBody().style.paddingRight = 'initial';
    if (options && options.fixed) {
      documentBody().style.position = 'initial';
    }
  } else {
    // Disable scroll and add padding in place of scrollbar
    if (hasScrollBar()) {
      documentBody().style.overflowY = 'hidden';
      documentBody().style['padding-right'] = scrollBarWidth() + 'px';
      if (options && options.fixed) {
        documentBody().style.position = 'fixed';
      }
    }
  }
}


// WEBPACK FOOTER //
// ./~/sp-components/util/scroll.js